// Paybill (M-Pesa C2B) payments (ADR 0020): the unmatched queue, matching by hand, and the
// notification addresses. Bill numbers go in request bodies, never in a URL.
import { queryOptions } from '@tanstack/react-query';
import {
  c2bBillLookupResultSchema,
  c2bEndpointListSchema,
  c2bEndpointViewSchema,
  c2bPaymentListSchema,
  createdC2bEndpointSchema,
  matchC2bPaymentResultSchema,
} from '@wodi/shared';
import { z } from 'zod';

import { api } from './client.ts';

export type PaybillStatus = 'unmatched' | 'matched';

export const paybillKeys = {
  all: ['paybill'] as const,
  list: (status: PaybillStatus) => ['paybill', 'payments', status] as const,
  endpoints: ['paybill', 'endpoints'] as const,
};

export const paybillPaymentsQuery = (status: PaybillStatus) =>
  queryOptions({
    queryKey: paybillKeys.list(status),
    queryFn: () =>
      api('GET', `/mpesa/c2b-payments?status=${status}&limit=100`, {
        schema: c2bPaymentListSchema,
      }),
  });

export const lookUpBill = (number: string) =>
  api('POST', '/mpesa/c2b-payments/bill-lookup', {
    body: { number },
    schema: c2bBillLookupResultSchema,
  });

export const matchPaybillPayment = (id: string, visitId: string, reason: string) =>
  api('POST', `/mpesa/c2b-payments/${id}/match`, {
    body: { visitId, reason },
    schema: matchC2bPaymentResultSchema,
  });

export const paybillEndpointsQuery = queryOptions({
  queryKey: paybillKeys.endpoints,
  queryFn: () => api('GET', '/mpesa/c2b-endpoints', { schema: c2bEndpointListSchema }),
});

export const createPaybillEndpoint = (label: string) =>
  api('POST', '/mpesa/c2b-endpoints', { body: { label }, schema: createdC2bEndpointSchema });

export const revokePaybillEndpoint = (id: string) =>
  api('POST', `/mpesa/c2b-endpoints/${id}/revoke`, {
    schema: z.object({ endpoint: c2bEndpointViewSchema }),
  });
